import { defineStore } from 'pinia';
import $api from '@/plugins/axios';

export const useDashboardStore = defineStore('DashboardStore', {
  state: () => {
    return {
      overview: {},
      studyTime: {
        summary: {
          lastStudyTimeSummaries: [],
          recentStudyTimeSummaries: [],
          studyTimePercentiles: {
            topTenAvgTimeSeconds: 0,
            bottomTenAvgTimeSeconds: 0,
          },
          studyTimeRanks: [],
        },
        trend: {
          recentDayAvgTotalTimeSeconds: 0,
          lastDayAvgTotalTimeSeconds: 0,
          recentTrendLineInfoList: [],
          lastTrendLineInfoList: [],
        },
      },
      studyRoom: {
        summary: {
          studyRoomCntSummary: {},
          topRankList: [],
          bottomRankList: [],
        },
        trend: {
          recentDayAvgUsedStudyRoomCnt: 0,
          lastDayAvgUsedStudyRoomCnt: 0,
          recentTrendLineInfoList: [],
          lastTrendLineInfoList: [],
        },
      },
      attendances: {
        summary: {
          attendanceCntSummary: {},
          topRankList: [],
          bottomRankList: [],
        },
        trend: {
          recentDayAvgAttendanceCnt: 0,
          lastDayAvgAttendanceCnt: 0,
          recentTrendLineInfoList: [],
          lastTrendLineInfoList: [],
        },
      },
    };
  },
  actions: {
    /** 개요 - 오늘 출석률 / 주간 접속자 수 / 이번 달 원생 수 */
    async setOverview(params) {
      try {
        const res = await $api.get('/dashBoard/overview', { params });
        this.overview = res;
      } catch(e) {
        this.$handleError(e);
      }
    },

    /** [공부기록] 요약 - 순공시간 기간별 요약 / 기간별 평균 비교 / 기간별 최대 공부기록 */
    async setStudyTimeSummary(params) {
      try {
        const res = await $api.get('/dashBoard/study-time/summary', { params });
        this.studyTime.summary = res;
      } catch(e) {
        this.$handleError(e);
      }
    },

    /** [공부기록] 추세 - 공부기록 일 평균 / 그래프 */
    async setStudyTimeTrend(params) {
      try {
        const res = await $api.get('/dashBoard/study-time/trend', { params });
        this.studyTime.trend = res;
      } catch(e) {
        this.$handleError(e);
      }
    },

    /** [스터디방] 요약 - 주간요약 / 방별 주간 최대 공부기록 / 방별 주간 최소 공부기록 */
    async setStudyRoomSummary(params) {
      try {
        const res = await $api.get('/dashBoard/study-room/summary', { params });
        this.studyRoom.summary = res;
      } catch(e) {
        this.$handleError(e);
      }
    },

    /** [스터디방] 추세 */
    async setStudyRoomTrend(params) {
      try {
        const res = await $api.get('/dashBoard/study-room/trend', { params });
        this.studyRoom.trend = res;
      } catch(e) {
        this.$handleError(e);
      }
    },

    /** [출결관리] 요약 - 주간요약 / 사용자별 주간 출석수 / 주간 출결현황 */
    async setAttendanceSummary(params) {
      try {
        const res = await $api.get('/dashBoard/attendances/summary', { params });
        this.attendances.summary = res;
      } catch(e) {
        this.$handleError(e);
      }
    },

    /** [출결관리] 추세 */
    async setAttendanceTrend(params) {
      try {
        const res = await $api.get('/dashBoard/attendances/trend', { params });
        this.attendances.trend = res;
      } catch(e) {
        this.$handleError(e);
      }
    },
    $handleError(e) {
      this.$nuxt.$sentry.captureException(e);
      this.$nuxt.error({ statusCode: e.response.status });
    }
  },
  getters: {
    diff: () => (first, last) => {
      const max = Math.max(first, last);
      const min = Math.min(first, last);

      return max - min;
    },
  },
});
